<template>
    <v-app>
        <v-main>
            <v-container
                    class="fill-height"
                    fluid
            >
                <v-card
                        :loading="loading"
                        class="mx-auto text-center"
                        min-width="400">

                    <img src="../assets/imparfaite-logo.svg" alt="Imparfaite." width="150" class="mt-10"/>

                    <v-card-title>
                        <h1>{{$t('password_reset.title')}}</h1>
                    </v-card-title>
                    <v-card-text class="px-10 pb-0 mb-10">
                        <v-form
                                v-if="!success"
                                ref="form"
                                v-model="valid">

                            <template v-if="!token">

                                <v-text-field
                                        type="email"
                                        id="email"
                                        :label="$t('global.email')"
                                        v-model="email"
                                        :rules="[rules.required]"
                                />
                            </template>
                            <template v-else>
                                <v-text-field
                                        type="password"
                                        id="password"
                                        :label="$t('global.password')"
                                        v-model="password"
                                        :rules="[rules.required]"
                                />

                                <v-text-field
                                        type="password"
                                        id="password-confirm"
                                        :label="$t('global.password_confirm')"
                                        v-model="password_confirm"
                                        :rules="[rules.required, rules.passwordMatch]"
                                />
                            </template>
                            <p>
                                <router-link :to="{ name: 'Login'}">{{$t('password_reset.back_to_login')}}</router-link>
                            </p>

                            <v-btn
                                    depressed
                                    tile
                                    :disabled="!valid || loading"
                                    color="primary"
                                    @click="apiLoginRequest"
                                    class="mt-4"
                            >
                                Validate
                            </v-btn>
                            <v-alert v-if="errors.length">
                                <ul>
                                    <li v-for="error in errors" :key="error">
                                        {{ error }}
                                    </li>
                                </ul>
                            </v-alert>
                        </v-form>
                        <template v-if="success && !token">
                            {{ $t('password_reset.mail_sent')}}
                        </template>
                        <template v-if="success && token">
                            {{ $t('password_reset.password_changed')}}
                            <br />
                            <router-link to="login">{{$t('password_reset.back_to_login')}}</router-link>
                        </template>
                    </v-card-text>
                </v-card>
                <v-snackbar
                        v-model="snackbar"
                        :color="color"
                >
                    {{ message }}
                    <v-btn
                            dark
                            text
                            @click="snackbar = false"
                    >
                        {{ $t('close') }}
                    </v-btn>
                </v-snackbar>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
    export default {
        name: 'PasswordReset',
        data() {
            return {
                email: '',
                password: '',
                password_confirm: '',
                snackbar: false,
                message: '',
                color: '',
                loading: false,
                errors: [],
                success: false,
                rules: {
                    required: value => !!value || this.$i18n.t('global.required'),
                    passwordMatch: (v) => v === this.password || this.$i18n.t('global.passwords_mismatch'),
                    min: v => v.length >= 8 || this.$i18n.t('global.password_too_short'),
                },
                valid: true,
            }
        },
        methods: {
            apiLoginRequest() {
                this.validate();
                this.loading = true;
                let promise;

                if (this.token) {
                    promise = this.axios
                        .post('sellers/passwords', {
                            password: this.password,
                            password_confirmation: this.password_confirm,
                            token: this.$route.query.token
                        });
                } else {
                    promise = this.axios
                        .post('sellers/passwords/recoveries', {email: this.email});
                }

                promise
                    .then(() => {
                        this.success = true;
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error(error);
                        return this.errors.push('An error occured.')
                    })
            },
            validate: function () {
                this.errors = [];
                this.$refs.form.validate();
            }
        },

        computed: {
            token() {
                return this.$route.query.token;
            }
        }
    }
</script>

<style lang="scss">

    h1 {
        font-size: 1.3em;
        text-align: center;
        width: 100%;
    }

    ul {
        padding: 0 !important;
        margin: 0;
        list-style-type: none;
        li {
            padding: 0;
            margin: 0;
        }
    }

</style>

